<template>

    <el-dialog :visible.sync="visible" width="960px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" :before-close="Close">
        <template slot="title">
            完成工单 - {{ wo.name }}
        </template>

        <div :style="{ backgroundColor: '#F5F7FA', borderRadius: '3px', padding: '15px 15px 5px 15px' }">
            <div :style="{ display: 'flex' }">
                <el-statistic title="预计工时/P">
                    <template slot="formatter">
                        <span style="font-size: 14px;">{{ day_predict }}</span>
                    </template>
                </el-statistic>

                <el-statistic title="消耗工时/P">
                    <template slot="formatter">
                        <span style="font-size: 16px;"><b>{{ day_consume }}</b></span>
                    </template>
                </el-statistic>

                <el-statistic title="剩余可用工时/P">
                    <template slot="formatter">
                        <span style="font-size: 14px;">{{ day_surplus }}</span>
                    </template>
                </el-statistic>
            </div>

            <el-steps :active="active" simple :style="{ marginTop: '20px', borderTop: '1px solid #eeeeee' }">
                <el-step title="1. 工时消耗" icon="el-icon-tickets"></el-step>
                <el-step title="2. 完成描述" icon="el-icon-collection"></el-step>
                <el-step title="3. 上传附件" icon="el-icon-folder-opened"></el-step>
            </el-steps>

        </div>

        <div :style="{ margin: '20px 0', height: '450px', overflow: 'auto' }" v-show="active == 0">
            <vxe-table ref="xTable" :data="table" :style="{ width: '100%' }">
                <vxe-column width="120" field="name" title="成员">
                    <template #default="{ row }">
                        <div style="display: flex; align-items: center; justify-content: flex-start;">
                            <el-avatar style="margin-right: 5px;" :size="26" :src="row.avatar"> {{ row.name[0] }} </el-avatar>
                            {{ row.name }}
                        </div>
                    </template>
                </vxe-column>

                <vxe-column width="220" field="day_consume" title="消耗工时 / D">
                    <template #default="{ row }">
                        <el-input v-model="row.hour_consume" @focus="focusFormUsers()" @blur="blurFormUsers()">
                            <template slot="append">小时</template>
                        </el-input>
                    </template>
                </vxe-column>

                <vxe-column title="完成时间">
                    <template #default>
                        <el-date-picker v-model="finish_at" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间" :style="{ width: '100%' }"></el-date-picker>
                    </template>
                </vxe-column>
            </vxe-table>

        </div>

        <div :style="{ margin: '20px 0', minHeight: '450px' }" v-show="active == 1">
            <froala-editor v-model="complete_describe" clean :height="360" :heightMax="360" v-if="active == 1 && visible" />
        </div>

        <div :style="{ margin: '20px 0', height: '450px', overflow: 'auto' }" v-show="active == 2">
            <files-upload v-model="files_id" model="contract" stage="完成工单" />
        </div>

        <div slot="footer">
            <div :style="{ display: 'flex', justifyContent: 'space-between' }">
                <div>
                    <el-button type="primary" @click="active -= 1" :disabled="!active">上一步</el-button>
                    <el-button type="primary" @click="active += 1" :disabled="active == 2">下一步</el-button>
                </div>

                <div>
                    <el-button size="mini" @click="Close()">取消</el-button>
                    <el-button size="mini" type="primary" @click="SubmitForm()" :loading="loading">确 定</el-button>
                </div>
            </div>
        </div>

    </el-dialog>

</template>

<script>

export default {

    data () {

        return {
            visible: false,
            loading: false,
            active: 0,
            wo: {
                user_receive: {},
                user_assist: []
            },
            finish_at: this.$lodash.date_time(),
            table: [],
            complete_describe: null,
            files_id: []
        }
    },

    computed: {
        day_predict () {
            return this.wo.day_predict
        },

        day_consume () {
            return this.table.reduce((sum, item) => Number(sum) + Number(item.day_consume), 0)
        },

        day_surplus () {
            return this.day_predict - this.day_consume
        }
    },

    methods: {
        Open (id) {
            this.$http.post('/9api/wo/search-first', { id: id, append: ['user_receive', 'user_assist'] }).then(rps => {
                this.wo = rps.data
                rps.data.user_assist.forEach((item, idx) => {
                    this.table.push({ ...item, day_consume: 0, hour_consume: 0 })
                })

                this.visible = true
            })

        },

        Close() {
            this.active = 0
            this.table = []
            this.visible = false
            this.complete_describe = null
            this.files_id = []
        },

        SubmitForm() {
            this.$http.post('/9api/pm/wo/update-finish', { id: this.wo.id, finish_at: this.finish_at, day_log: this.table, complete_describe: this.complete_describe, files_id: this.files_id }).then(rps => {
                this.$emit('onChange', rps.data)
                this.Close()
            })

        },

        focusFormUsers() {
            this.loading = true
        },

        blurFormUsers() {
            this.table.forEach(element => {
                element.hour_consume = (Number(element.hour_consume) || 0).toFixed(2)
                element.day_consume = (element.hour_consume / 8).toFixed(2)
            })

            this.loading = false
        }

    }

}

</script>

